const validateMessagesEN = {
  required: 'This field is required!',
  types: {
    email: '${label} is not a valid email!'
  }
};

const validateMessagesES = {
  required: 'Este campo es requerido!',
  types: {
    email: '${label} no es un email válido!'
  }
};

export default {
  validateMessagesEN,
  validateMessagesES
};